/**
 * 系统模块
 * ims-system
 */
import { SERVICE_PREFIX } from '@mts/utils';
import { createAxios } from '@mts/utils/http/axios';

const http = createAxios({ requestOptions: { urlPrefix: SERVICE_PREFIX.ISYS } });

export interface SysConfig {
  id?: string;
  configKey: string;
  configKeyList?: string[];
  configValue: string;
  usageScene?: 'default' | 'table_cache' | 'search_cache' | 'pivot';
  remark?: string;
  ownerId?: string;
  version?: number;
}
export type SysConfigType = 'system' | 'user';
export type SysConfigValue = string | number | boolean | object | undefined;

/** 获取格式化后的配置值 */
export const parseConfigValue = (item?: SysConfig): SysConfigValue => {
  if (!item) return item;
  try {
    return JSON.parse(item.configValue);
  } catch (e) {
    return item.configValue;
  }
};

export default {
  /** 获取系统配置列表 */
  getSysConfigList: (params?: Partial<SysConfig>, type: SysConfigType = 'user') =>
    http.post<SysConfig[]>({
      url: `/config/${type}/list`,
      params: { usageScene: 'default', ...params },
    }),
  /** 获取系统配置 */
  getSysConfig: (params?: Partial<SysConfig>, type: SysConfigType = 'user') =>
    http.post<SysConfig>({ url: `/config/${type}/detail`, params }),
  /** 保存系统配置 */
  saveSysConfig: (params?: SysConfig, type: SysConfigType = 'user') =>
    http.post<SysConfig>({
      url: `/config/${type}/save`,
      params: { usageScene: 'default', ...params },
    }),
  /** 删除系统配置 */
  deleteSysConfig: (params: Partial<SysConfig> | SysConfig['id'], type: SysConfigType = 'user') =>
    http.post({
      url: `/config/${type}/removeBy${typeof params === 'string' ? 'Id' : 'Param'}`,
      params,
    }),
};
